import type {
  OptInFeatureListRequest,
  OptInFeatureUsersRequest,
} from '../Types/OptInFeatures.types';

export const optInFeaturesQueryKeys = {
  all: ['opt-in-features'] as const,
  lists: () => [...optInFeaturesQueryKeys.all, 'list'] as const,
  list: (params: OptInFeatureListRequest) => [...optInFeaturesQueryKeys.lists(), params] as const,
  details: () => [...optInFeaturesQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...optInFeaturesQueryKeys.details(), id] as const,
  adoption: (id: string) => [...optInFeaturesQueryKeys.all, 'adoption', id] as const,
  users: (id: string, params: OptInFeatureUsersRequest) =>
    [...optInFeaturesQueryKeys.all, 'users', id, params] as const,
};
